import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import MessageWrapperBase from './MessageWrapperBase';
import { FormattedMessage } from 'react-intl';

// eslint-disable-next-line react-refresh/only-export-components
export const MessageWrapper = styled(MessageWrapperBase)(
  ({ theme }) => ({
    paddingTop: 64,
    paddingBottom: 64,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '.MuiCircularProgress-root': {
      marginRight: 12,
      color: theme.palette.text.secondary,
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    backgroundColor: theme.isDark ? 'black' : undefined,
  })),
);

const OneDriveLoadingMessage = () => (
  <MessageWrapper>
    <CircularProgress size={24} />
    <p>
      <FormattedMessage id="portfolio.challenge.files.add.select.onedrive.file_picker.messages.onedrive_loading" />
    </p>
  </MessageWrapper>
);

export default OneDriveLoadingMessage;
